import { Link, Outlet, useRouterState } from "@tanstack/react-router";

/**
 * Vault settings layout — a lean sidebar (Profile / Preferences) + outlet.
 * Replaces the advisor VaultSettingsLayoutContainer, which is built on the
 * shared app-sidebar + org-aware user-settings queries.
 */
const TABS = [
  { to: "/settings/profile", label: "Profile" },
  { to: "/settings/preferences", label: "Preferences" },
] as const;

export function SettingsLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <div className="flex flex-col gap-8 md:flex-row">
      <aside className="md:w-56 md:shrink-0">
        <nav className="flex gap-1 md:flex-col">
          {TABS.map((tab) => {
            const active = pathname.startsWith(tab.to);
            return (
              <Link
                key={tab.to}
                to={tab.to}
                className={
                  "rounded-md px-3 py-2 text-sm font-medium no-underline transition-colors " +
                  (active
                    ? "bg-primary/10 text-primary"
                    : "text-muted-foreground hover:text-foreground")
                }
              >
                {tab.label}
              </Link>
            );
          })}
        </nav>
      </aside>
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
